import React from 'react'

// Gmail 계정 메일의 별표 토글 (gmail-star-display) — 꺼짐. `IcUnflagged` 와 같은 16px 규격.
interface IcUnstarredProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcUnstarred: React.FC<IcUnstarredProps> = ({
  width = '16px',
  height = '16px',
  color = '#6B7280',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <path
        d="M8 1.91L9.51 6.56H14.4L10.44 9.44L11.96 14.09L8 11.21L4.04 14.09L5.56 9.44L1.6 6.56H6.49Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IcUnstarred
